import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import BlockList from 'components/application/BlockList';

import { resourceShape } from 'components/helpers/serialisableResources';
import { personDisplayName } from 'components/helpers/users';

export default function PersonnelSidePanelSubordinatesTab({
  loadMoreRef,
  metaData,
  subordinates,
}) {
  const { t: i18nTCommon } = useTranslation('common');

  return (
    <div>
      {subordinates.length > 0 ?
        <BlockList
          collection={subordinates}
          onItemDisplay={(subordinate) => (
            <div className='block-list__item--flex-container'>
              <span className='truncated-text-container truncated-text-container--width-auto'>
                {personDisplayName({ attributes: subordinate.attributes })}
              </span>
            </div>
          )}
        />
      : <div className='tw-px-5 tw-py-6 tw-text-grey-400'>
          {i18nTCommon('shared.notSet')}
        </div>
      }
      {!metaData.isLastPage && subordinates.length !== 0 && (
        <li className='block-list__item tw-border-grey-100' ref={loadMoreRef}>
          <div className='block-list__item--flex-container'>
            <div className='block-list__item--align-center'>
              <span>{i18nTCommon('personnel.loadingPersonnel')}</span>
            </div>
          </div>
        </li>
      )}
    </div>
  );
}

PersonnelSidePanelSubordinatesTab.propTypes = {
  subordinates: PropTypes.arrayOf(resourceShape('personnel')),
  loadMoreRef: PropTypes.func.isRequired,
  metaData: PropTypes.object.isRequired,
};
